module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2020_05.a2c7c25e.jpg";